import axios from './axiosConfig'

export const getAllAdmin = async () => {
  const response = await axios.get('/admin')

  console.log('admin all: ', response.data)
  return response.data
}

export const createAdmin = async (formData) => {
  try {
    const response = await axios.post('/admin/create', {
      username: formData.username,
      fullName: formData.fullName,
      password: formData.password,
      role: formData.role,
    })
    return response.data
  } catch (error) {
    console.error('Error creating customise:', error)
    throw error
  }
}

export const blockAdmin = async (id) => {
  const response = await axios.put(`/admin/${id}/block`)

  console.log('block: ', response.data)
  return response.data
}

export const unblockAdmin = async (id) => {
  const response = await axios.put(`/admin/${id}/unblock`)

  console.log('unblock: ', response.data)
  return response.data
}

export const deleteAdmin = async (id) => {
  const response = await axios.delete(`/admin/${id}`)
  return response.data
}

export const addPermission = async (id, permissions) => {
  console.log('permission', permissions)
  const response = await axios.post(`/admin/${id}/permissions`, permissions)
  console.log('addper data:', response)
  return response.data
}

export const showPermission = async (id) => {
  const response = await axios.get(`/admin/${id}/permissions`)
  console.log('permission data:', response.data)
  return response.data
}

//nothing chnages  done